import { collections } from "@/mocks/gossip";

const badgeMap: Record<string, string> = {
  accent: "bg-accent-100 text-accent-900",
  primary: "bg-primary-100 text-primary-900",
  secondary: "bg-secondary-100 text-secondary-900",
};

export default function CollectionsBand() {
  return (
    <section id="collection" className="mt-2 bg-background-100 py-10 md:py-14">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <div className="mb-6 flex items-center justify-between gap-3">
          <div>
            <div className="mb-1.5 flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-primary-700">
              <i className="ri-folder-5-fill"></i>专题合集
            </div>
            <h2 className="font-heading text-xl font-black text-foreground-950 md:text-2xl">同一条瓜，从开扒到落地都在这里</h2>
            <p className="mt-1 text-sm text-foreground-600">一个瓜一条主线，专题合集帮你连瓜不遗漏，楼层跟进新进展随时顶上。</p>
          </div>
          <a href="#feed" className="hidden shrink-0 items-center gap-1 whitespace-nowrap text-sm text-foreground-600 hover:text-primary-700 sm:inline-flex">
            全部专题<i className="ri-arrow-right-line text-xs"></i>
          </a>
        </div>
      </div>

      <div className="mx-auto max-w-[1240px] overflow-x-auto px-4 pb-2 no-scrollbar md:px-6">
        <div className="grid auto-cols-[minmax(240px,280px)] grid-flow-col gap-4">
          {collections.map((c, i) => (
            <article
              key={c.title}
              className="group animate-float-up w-full overflow-hidden rounded-lg border border-background-200 bg-background-50"
              style={{ animationDelay: `${i * 70}ms` }}
            >
              <a href="#floor" className="relative block aspect-[3/4] w-full overflow-hidden">
                <img
                  src={c.cover}
                  alt={`${c.title}专题封面`}
                  className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-transparent to-transparent"></div>
                <div className="absolute left-3 top-3">
                  <span className={"whitespace-nowrap rounded px-2 py-0.5 text-[11px] font-medium " + badgeMap[c.tone]}>
                    {c.entries} 篇在扒
                  </span>
                </div>
                <div className="absolute inset-x-0 bottom-0 p-3.5 md:p-4">
                  <h3 className="font-heading text-lg font-bold leading-snug text-white">{c.title}</h3>
                  <p className="mt-1 text-xs text-white/75">{c.sub}</p>
                  <div className="mt-2.5 flex items-center justify-between">
                    <span className="inline-flex items-center gap-1 text-[11px] text-accent-300">
                      <i className="ri-eye-line"></i>{c.follow} 在蹲
                    </span>
                    <span className="inline-flex items-center gap-1 text-[11px] text-white/80">
                      进入合集<i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </div>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}